/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
import Wizard from './wizard';
import Helpers from './helpers';
import FormToJSON from './form-to-json';
import Ping from './ping';

const CreateProject = {
	form: null,
	saveForLaterButtonArray: [],
	// wire everything up
	init({ form }) {
		Wizard.init();
		if (form) {
			this.form = form;
			this.errorPing = {
				heading: form.dataset?.pingSadHeading,
				body: form.dataset?.pingSadBody,
			};
			// add custom event to listen if it's time to submit
			window.addEventListener('submit-form', () => {
				Helpers.disableAllButtons();
				this.handleFormSubmit();
			});
			// get save for later
			this.saveForLaterButtonArray = Array.from(document.querySelectorAll('[data-save-for-later]'));
			if (this.saveForLaterButtonArray && this.saveForLaterButtonArray.length > 0) {
				this.saveForLaterButtonArray.forEach((btn) => {
					btn.addEventListener('click', (e) => {
						Helpers.disableAllButtons();
						this.handleSaveForLater(e);
					});
				});
			}
			if (Helpers.getUrlVars().p) {
				this.getProject(Helpers.getUrlVars().p, this.prefillForm);
			}
		}
	},

	// A handler function to prevent default submission and run our custom script.
	handleFormSubmit() {
		// Call our function to get the form data.
		Helpers.saveCodeMirrorInput();
		const data = this.form;
		if (data) {
			this.sendRequest(data, true);
			window.dispatchEvent(
				new CustomEvent('lightbox-show-by-template-id', {
					detail: {
						templateId: 'popUpAiAssistantHelper',
					},
				})
			);
		}
	},

	// A handler function to prevent default action and run our custom script.
	handleSaveForLater(event) {
		event.preventDefault();
		Helpers.saveCodeMirrorInput();
		const data = this.form;
		if (data) {
			this.sendRequest(data, false, () => {
				event.target.disabled = false;
			});
		}
	},

	prefillForm(formData) {
		const formDataJson = JSON.parse(formData);

		if (formData.rawJson === null) return false;
		const formDataEntries = Object.entries(JSON.parse(formDataJson.rawJson));
		// eslint-disable-next-line no-restricted-syntax
		for (const [fieldName, fieldValue] of formDataEntries) {
			const input = document.getElementsByName(fieldName);
			for (let i = 0; i < input.length; i += 1) {
				switch (input[i].type) {
					case 'checkbox':
						for (let index = 0; index < fieldValue?.length; index += 1) {
							if (input[i].value === fieldValue[index]) input[i].checked = true;
							if (fieldValue !== null) {
								const target = input[i].getAttribute('data-element-to-toggle');
								const toggleTarget = document.querySelector(`[data-toggle-target="${target}"]`);
								if (toggleTarget) {
									toggleTarget.classList.add('is-visible');
								}
							}
						}
						break;
					case 'radio':
						if (input[i].value === fieldValue) {
							input[i].checked = true;
							// Check if fieldValue is not null and toggle the item underneath
							if (fieldValue !== null) {
								const target = input[i].getAttribute('data-element-to-toggle');
								const toggleTarget = document.querySelector(`[data-toggle-target="${target}"]`);
								if (toggleTarget) {
									toggleTarget.classList.add('is-visible');
								}
							}
						}
						break;
					case 'textarea':
						// check if is codemirror textarea
						if (input[i].dataset.codemirror && fieldValue != null) {
							input[i].nextSibling.CodeMirror.getDoc().setValue(fieldValue);
							break;
						}
						input[i].value = fieldValue;
						break;
					case 'select':
						const selectedOption = input[i].querySelector(`option[value="${fieldValue}"]`);
						input[i].selectedIndex = selectedOption.index;

						break;
					case 'date':
						const date = new Date(fieldValue);
						const [isoDate] = date.toISOString().split('T');
						input[i].value = isoDate;
						break;
					default:
						input[i].value = fieldValue;
						break;
				}
			}
		}
		if (formDataJson.imageUrl) {
			const imageInput = document.getElementById('ProjectImage');
			if (imageInput) imageInput.dataset.validation = '';
			const insertNode = document.getElementById('previewContainer');
			if (insertNode) {
				Helpers.renderPreview(insertNode, formDataJson.imageUrl);
			}
		}
		return true;
	},

	handleXHRError() {
		Ping.createSadPing(this.errorPing?.heading, this.errorPing?.body);
		Helpers.enableAllButtons();
	},

	sendRequest(form, finalize) {
		const xhr = new XMLHttpRequest();
		const apiUrl = finalize
			? '/umbraco/api/projectformulation/savefinal'
			: '/umbraco/api/projectformulation/savedraft';

		const formData = new FormData();

		const formAsJSON = FormToJSON(form);
		if (!formAsJSON || formAsJSON === '') {
			this.handleXHRError();
			return false;
		}

		formData.append('projectData', JSON.stringify(formAsJSON));

		const fileInput = document.getElementById('ProjectImage');
		if (fileInput && fileInput.files && fileInput.files[0]) {
			formData.append('ProjectImage', fileInput.files[0]);
		}

		xhr.open(this.form.method, apiUrl, true);
		xhr.setRequestHeader('Culture', document.documentElement.lang); // This is fine

		xhr.send(formData);

		xhr.onerror = () => {
			this.handleXHRError();
		};

		xhr.onloadend = () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				const jsonResponse = xhr.responseText ? JSON.parse(xhr.responseText) : null;
				this.notifySaveSuccess(jsonResponse, finalize);
			} else if (xhr.status === 500) {
				this.handleXHRError();
			}
		};

		return true;
	},

	notifySaveSuccess(jsonResponse, finalize) {
		if (finalize) {
			if (jsonResponse != null) window.location.href = jsonResponse.redirectUrl;
		} else {
			if (jsonResponse?.ping != null) {
				Ping.createHappyPing(jsonResponse.ping?.pingHeading, jsonResponse.ping?.pingBody);
			} else {
				this.handleXHRError();
			}
			Helpers.enableAllButtons();
		}
	},

	getProject(guid, callback) {
		const xhr = new XMLHttpRequest();
		const apiUrl = `/umbraco/api/projectformulation/get?key=${guid}`;
		xhr.open('GET', apiUrl, true);
		xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
		xhr.setRequestHeader('Culture', document.documentElement.lang);

		// send the collected data as JSON
		xhr.send();

		xhr.onerror = () => {
			this.handleError();
		};

		xhr.onloadend = () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				callback(xhr.responseText);
			}
		};
	},
};

export { CreateProject as default };
